import { useFetcher } from "react-router";
import React from "react";
import { ArrowRepeat } from "react-bootstrap-icons";
import {
  Button,
  FormControl,
  FormGroup,
  FormLabel,
  Modal,
} from "react-bootstrap";
import { WithAggregator } from "./AggregatorDetail.js";
import { UpdateAggregator, formikErrors } from "../ApiClient.js";
import { FormikErrors } from "formik";

export default function RotateBearerTokenButton() {
  const [show, setShow] = React.useState(false);
  const close = React.useCallback(() => {
    // eslint-disable-next-line @eslint-react/set-state-in-effect
    setShow(false);
  }, []);
  const open = React.useCallback(() => setShow(true), []);
  const fetcher = useFetcher();
  const [errors, setErrors] = React.useState(
    null as null | FormikErrors<UpdateAggregator>,
  );

  React.useEffect(() => {
    if (fetcher.data) {
      if ("error" in fetcher.data) {
        // eslint-disable-next-line @eslint-react/set-state-in-effect
        setErrors(formikErrors(fetcher.data.error));
      } else {
        close();
        // eslint-disable-next-line @eslint-react/set-state-in-effect
        setErrors(null);
      }
    }
  }, [fetcher.data, close]);

  return (
    <>
      <Button
        variant="outline-secondary"
        className="ml-auto"
        size="sm"
        onClick={open}
      >
        <ArrowRepeat /> Rotate Token
      </Button>
      <Modal show={show} onHide={close}>
        <fetcher.Form method="PATCH">
          <Modal.Header closeButton>
            <Modal.Title>
              Rotate Bearer Token for{" "}
              <WithAggregator>{({ name }) => `"${name}"`}</WithAggregator>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup controlId="bearer_token">
              <FormLabel>New Bearer Token</FormLabel>
              <FormControl
                name="bearer_token"
                type="text"
                isInvalid={!!errors?.bearer_token}
              />
              <FormControl.Feedback type="invalid">
                {errors?.bearer_token}
              </FormControl.Feedback>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={close}>
              Close
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={fetcher.state === "submitting"}
            >
              <ArrowRepeat /> Rotate
            </Button>
          </Modal.Footer>
        </fetcher.Form>
      </Modal>
    </>
  );
}
